import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { Link } from 'react-router'

import Actions from './actions'
import Collapsible from '../collapsible'
import Progress from './progress'

@observer(['globals', 'invoices'])
export default class InvoiceList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            loadableState: true,
            dateRange: 30
        }
    }

    loadInvoices(callback) {
        this.props.invoices.loadInvoicesByDateRange(this.state.dateRange, () => {
            this.setLoadableState(false)

            if (callback) {
                callback()
            }
        })
    }

    loadInvoicesByDateRange(dateRange) {
        this.setLoadableState(true)
        this.setState({
            dateRange: dateRange
        }, () => {
            this.loadInvoices()
        })
    }

    reload(callback) {
        this.props.reload(() => {
            if (callback != null) {
                callback()
            }
        })
    }

    setLoadableState(loadableState) {
        this.props.setLoadableState(loadableState)
    }

    priceFormatter(cell, row) {
        return '$' + cell.toFixed(2)
    }

    percentFormatter(cell, row) {
        return cell + '%'
    }

    balanceDue(cell, row) {
        /*
        let balance = row.oneTimeTotal - row.paymentAmount
        return  '$' + balance.toFixed(2)
        */

       return  '$' + cell.toFixed(2)
      }

    companyFormat(cell, row) {
        let linkURL = '/company/details/' + row.companyId
        return (
            <div>
                <Link to={ linkURL }>{ row.companyName }</Link><br />
                <small>Invoice #: { row.id }</small><br />
                <small>{ row.quoteType[0].toUpperCase() + row.quoteType.substr(1) } - Created { row.formattedQuoteDate }</small>
            </div>
        )
    }

    progressActions(cell, row) {
        return <Progress row={row} reload={this.reload.bind(this)} setLoadableState={this.setLoadableState.bind(this)} />
    }
    
    formatActions(cell, row) {
        return <Actions row={row} reload={this.reload.bind(this)}  setLoadableState={this.setLoadableState.bind(this)} />
    }

    render() {
        const options = {
            defaultSortName: 'id',
            defaultSortOrder: 'desc'
        }

        const invoicesTable = (
          <BootstrapTable
            data={this.props.data}
            striped={true}
            hover={true}
            pagination={true}
            search={true}
            options={options}
            exportCSV={true}
          >
            <TableHeaderColumn width="75" dataField="companyName" hiddenOnInsert={true} dataFormat={this.companyFormat.bind(this)} isKey={true} dataSort={true} >Company</TableHeaderColumn>
            <TableHeaderColumn width="25" dataField="oneTimeTotal" dataFormat={this.priceFormatter.bind(this)} dataSort={true}>Total</TableHeaderColumn>
            <TableHeaderColumn width="25" dataField="paymentAmount" dataFormat={this.priceFormatter.bind(this)} dataSort={true}>Paid</TableHeaderColumn>
            <TableHeaderColumn width="25" dataField="balanceDue" dataFormat={this.balanceDue.bind(this)} dataSort={true}>Balance</TableHeaderColumn>
            <TableHeaderColumn width="100" dataField="id" hiddenOnInsert={true} autoValue={true} dataFormat={this.progressActions.bind(this)}>Progress</TableHeaderColumn>
            <TableHeaderColumn width="100" datafield="id" hiddenOnInsert={true} autoValue={true} dataFormat={this.formatActions.bind(this)}>Actions</TableHeaderColumn>
          </BootstrapTable>
        )

        return (
          <Collapsible title={ this.props.pageTitle } content={invoicesTable} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/invoices/invoicelist.js